import { useContext } from 'react';
import { useConfig } from '@byte-design/config';
import { TableTheme } from '../context/theme';
export function useTableTheme() {
  var _useContext = useContext(TableTheme),
      _useContext$size = _useContext.size,
      size = _useContext$size === void 0 ? 'md' : _useContext$size,
      headGroupHeight = _useContext.headGroupHeight,
      headRowHeight = _useContext.headRowHeight,
      rowHeight = _useContext.rowHeight;

  var config = useConfig();
  var sizeInfo = config.table.size[size];
  return {
    size: size,
    headGroupHeight: headGroupHeight != null ? headGroupHeight : sizeInfo.group,
    headRowHeight: headRowHeight != null ? headRowHeight : sizeInfo.head,
    rowHeight: rowHeight != null ? rowHeight : sizeInfo.row
  };
}